import { Card, CardContent, CardHeader } from "@/ui/base/card";
import { cn } from "@/nucleo/utilitarios";
import { type LucideIcon } from "lucide-react";

interface FormSectionProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({ title, subtitle, icon: Icon, children, className }: FormSectionProps) {
  return (
    <Card className={cn(
      "rounded-2xl border border-border/60 bg-card shadow-xs overflow-hidden",
      className,
    )}>
      <CardHeader className="pb-4 space-y-1">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="shrink-0 rounded-xl p-2.5">
              <Icon className="h-4 w-4 text-primary/70" />
            </div>
          )}
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{title}</h3>
            {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 pt-0">
        {children}
      </CardContent>
    </Card>
  );
}
